import { styled } from "@mui/material";
import { DataGridPlaceholder } from "@volt_developers/components";
import { Link } from "react-router-dom";

import type { ReactNode } from "react";
import type { NonUndefined } from "../utils/types";

interface PageErrorProps {
  title: NonUndefined<ReactNode>;
  description: NonUndefined<ReactNode>;
  goBackLink: string;
  buttonLabel: ReactNode;
}

export function PageError({
  title,
  description,
  goBackLink,
  buttonLabel,
}: PageErrorProps) {
  return (
    <MainWrapper>
      <InnerWrapper>
        <DataGridPlaceholder.Header data-testid="not-found-header">
          {title}
        </DataGridPlaceholder.Header>
        <DataGridPlaceholder.Description data-testid="not-found-description">
          {description}
        </DataGridPlaceholder.Description>
        <DataGridPlaceholder.Button
          component={Link}
          data-testid="not-found-button"
          to={goBackLink}
        >
          {buttonLabel}
        </DataGridPlaceholder.Button>
      </InnerWrapper>
    </MainWrapper>
  );
}

const InnerWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  maxWidth: 377,
  color: theme.palette.text.high,
}));

const MainWrapper = styled("div")(({ theme }) => ({
  gridColumnStart: 1,
  gridColumnEnd: -1,
  width: "100%",
  minHeight: "330px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(4),
}));
